import { __awaiter, __generator } from "tslib";
import { multiToggleKey } from './';
export var createMultiToggleDriver = function (wrapper) {
    var base = wrapper.$("." + multiToggleKey);
    return {
        getSelected: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$('.toggle-btn.selected').text()];
        }); }); },
        clickButton: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            var buttons, _a, button;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        buttons = base.$$('.toggle-btn');
                        _a = index;
                        return [4 /*yield*/, buttons.count()];
                    case 1:
                        if (!(_a < (_b.sent()))) return [3 /*break*/, 3];
                        button = buttons.get(index);
                        return [4 /*yield*/, button.click()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        countButtons: function () { return base.$$('.toggle-btn').count(); },
        getSelectedIdx: function () { return base.$$('.toggle-btn')
            .map(function (item) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, item.hasClass('selected')];
        }); }); })
            .then(function (arr) { return arr.indexOf(true); }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map